import {
  isCheckoutBlockedByWarnings,
  UnderwritingWarning
} from '@insurance/utils'
import { Alert } from 'antd'
import { useTranslation } from 'react-i18next'

type Props = {
  warnings?: UnderwritingWarning[]
  style?: React.CSSProperties
}

export const UnderwritingWarningsAlert = ({ warnings, style }: Props) => {
  const { t } = useTranslation()

  if (!warnings?.length) return null

  const isBlocking = isCheckoutBlockedByWarnings(warnings)

  return (
    <Alert
      type={isBlocking ? 'error' : 'warning'}
      showIcon
      description={
        <ul style={{ margin: 0, paddingLeft: 16 }}>
          {warnings.map((warning) => (
            <li key={warning.code}>{t(warning.code, warning.message)}</li>
          ))}
        </ul>
      }
      style={{ marginBottom: 12, ...style }}
    />
  )
}
